import classNames from 'classnames'

import style from './ProductOrderHeader.module.scss'

type ProductOrderHeaderProps = {
  step?: string
  title: string
  description?: string
}

// шапка заявки
export function ProductOrderHeader({
  step,
  title,
  description,
}: ProductOrderHeaderProps) {
  return (
    <header className={style.header}>
      {step && <span className={style.step}>{step}</span>}
      <span className={classNames('h1', style.title)}>{title}</span>
      {description && <span className={style.description}>{description}</span>}
    </header>
  )
}
